module.exports = __webpack_public_path__ + "assets/img/banner9.1e566591.png";